module.exports = __webpack_public_path__ + "static/wallpaper6-f375c75dcba29e6091638fc9b0efccf5.jpg";